import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const paymentInfo = Loadable(() => (isFuncComp() ? import('../../FuncContainers/web/paymentInfo') : import('../../containers/web/paymentInfo')));

export default MapTo('vcg/components/soe-home/react/paymentInfo')(paymentInfo);
